import React from 'react';
import { GridContainer, GridItem,  IconButton} from '../../components';
import { Card, CardContent } from '@material-ui/core';
import { UpsellServiceImage } from '../../models/UpsellServiceImage';

interface IProps {
  onButtonClick?: (title: string) => React.MouseEventHandler<HTMLButtonElement> | undefined;
  items: UpsellServiceImage[];
}

export const HotelServiceCard: React.FC<IProps> = ({ 
    onButtonClick,
    items,
}) => {
  return (
        <Card elevation={3}>
            <CardContent>
                    <GridContainer spacing={2} >
                        {items.map((item, index) => (
                            <GridItem key={index} xs={12} sm={4}>
                                <IconButton imageUrl={item.imageUrl} title={item.title} onClicked={onButtonClick?.(item.title)} />
                            </GridItem>
                            ))}
                    </GridContainer>
            </CardContent>
        </Card>
  );
};
